import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';

export default function Footer() {
  const { lang, toggleLang, t } = useLanguage();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="site-footer-neo">
      <div className="container">
        <div className="footer-inner-neo">
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.85rem' }}>
            <Logo />
            <div>
              <span style={{ color: '#ffffff', fontWeight: 800 }}>
                {t.personalInfo.name.toUpperCase()}
              </span>
              <span style={{ color: 'var(--text-muted)', marginLeft: '8px' }}>
                {'//'} ARCHIVE_{new Date().getFullYear()} · {t.personalInfo.location.toUpperCase()}
              </span>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1.25rem' }}>
            <button
              type="button"
              className="lang-toggle-neo"
              onClick={toggleLang}
              aria-label="Dili Değiştir / Switch Language"
            >
              <span className={lang === 'tr' ? 'lang-active-neo' : ''}>TR</span>
              <span style={{ color: '#525866' }}>|</span>
              <span className={lang === 'en' ? 'lang-active-neo' : ''}>EN</span>
            </button>

            <button
              type="button"
              className="btn-neo btn-neo-dark"
              onClick={scrollToTop}
              style={{ padding: '0.35rem 0.85rem', fontSize: '0.82rem' }}
              aria-label="Başa Dön"
            >
              <span>{t.ui.backToTop}</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
